import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ArcgisFilter from './ArcgisFilter';
import * as webMercatorUtils from '@arcgis/core/geometry/support/webMercatorUtils';
import { v4 as uuidv4 } from 'uuid';
import { filterOperations } from '../../redux/filter';
import { incidentsOperations } from '../../redux/incidentList';
import { buildFilter } from './utils/sqlUtils';
import { userOperations } from '../../redux/user';
import fieldsDefinition from './defaults/incidentFields.json';

import { setCustomFilterDefinitionExpression, setMapViewTarget } from '../esri/mapHub';
import './CustomFiltersDialog.css';

class CustomFiltersDialog extends Component {

  constructor (props)
  {
    super(props);
 
    this.state =
    {
      filter: '',
      filterState: null,
      filterTitle: props.filterTitle,
      hasSpatialFilter: false,
      spatialFilterId: null,
      showFilterDialog: false,
      spatialFilters: []
    };
  }

  componentWillReceiveProps(nextProps)
  {
    if (nextProps.filterTitle !== this.props.filterTitle)
    {
      this.setState(
        {
          filterTitle: nextProps.filterTitle
        });
    }
  }

  saveFilter = () => {

    const filter = Object.assign({},this.state.filterState);

    if (this.props.filterForEdit !== null && this.props.filterForEditId !== null)
    {
      if (this.props.filterTitle !== this.state.filterTitle && (this.state.filterTitle !== ''))
      {
        filter.title = this.state.filterTitle;
      }
      window.api.updateCustomFilter(this.props.filterForEditId, filter.title, filter).then((response) => {   
       
        this.props.setCustomFilters(response);
        let activeDefinitionExpression = buildFilter(filter);
        this.props.setActiveCustomFilter(filter, activeDefinitionExpression);
        this.props.setFilterLoading(true);

        setCustomFilterDefinitionExpression(activeDefinitionExpression).then( response => {
          this.props.setQueriedIncidentsTotal(response.total);
          this.props.setDisplayedIncidentsCount(response.features.length);
          this.props.setIncidents(response.features);
          this.props.setVisibleIncidents(response.features);
          this.props.setFilterLoading(false);
        });
      });
    }
    else
    {
      filter.title = (this.state.filterTitle !== '') ? this.state.filterTitle : this.props.filterTitle;
      filter.filterGuid = uuidv4();
      window.api.addCustomFilter(filter.title, filter).then((response) => {  
        this.props.setCustomFilters(response);
      });
    }

    this.setState(
      {
        filter: null,
        filterState: null,
        filterTitle: '',
        isEditingFilter: false
      }
    );

    let activeDefinitionExpression = buildFilter(filter);
    this.props.setActiveCustomFilter(filter, activeDefinitionExpression);
    this.props.setBasicFilterActive(false);

    setCustomFilterDefinitionExpression(activeDefinitionExpression).then( response => {
      this.props.setQueriedIncidentsTotal(response.total);
      this.props.setDisplayedIncidentsCount(response.features.length);
      this.props.setIncidents(response.features);
      this.props.setVisibleIncidents(response.features);
    });
    this.props.onClose();
  }
  handleFilterChanged = (filter, filterState) => {
    this.setState({ filter, filterState });
  };

  handleUseSpatialFilterChange = (event) => {
    const filterChecked = (event.target.checked);
    
    if (filterChecked) 
    {
      window.api.getSpatialFiltersForUser().then(response => {
        this.setState({ spatialFilters: response });
      });
    }
    this.setState(
      {
        showFilterDialog: filterChecked
      });
  }

  filterSelected = (filter) => {

  
  this.props.setGeometry(filter.geometry);
  this.props.setSpatialFilterID(filter.attributes.OBJECTID);

  let geomWGS84 = webMercatorUtils.webMercatorToGeographic(filter.geometry);

  setMapViewTarget({
    target: geomWGS84
  });

  this.onShapeLibraryDialogClose();
}

  setSpatialFilters = (filters) => {
    this.setState({ spatialFilters: filters });
  }
  
  onShapeLibraryDialogClose = () => {
		this.setState({ showFilterDialog: false });
	}

  handleOnNameChange = e => {
      this.setState(
        {
          filterTitle:  e.target.value
        }
      );
  };

  render() {

    const actions = [
        <Button
        className="reporting-print-btn"
        variant="contained" color="primary"
        onClick={this.saveFilter}
        disabled={(this.state.filterTitle === null || this.state.filterTitle === '')}>Save</Button>,
      <Button
        className="reporting-print-btn"
        onClick={this.props.onClose}>Close</Button>
    ];

    return (
      <Dialog
        open={this.props.open}
        actions={actions}
        modal={true}
        fullScreen
        autoScrollBodyContent={true}
        contentStyle={{maxWidth: 'none', minHeight: '400'}}
        className="dialog-modal">
        <div style={{display: "flex", alignItems: "flex-start", flexDirection: "row", marginBottom: "22px"}}>
          Filter Name: <TextField style={{ marginLeft: "15px", marginTop: "-6px", width: "500px"}} defaultValue={this.props.filterTitle} onChange={this.handleOnNameChange} />
        </div>
       
      <ArcgisFilter
        filterState={(this.props.filterForEdit) ? JSON.parse(this.props.filterForEdit.FilterContent) : null }
        fields={fieldsDefinition}
        disableUnique={true}
        onChange={this.handleFilterChanged}/>
      </Dialog>
    )
  }
}

const mapStateToProps = state => ({
  filter: state.filter,
  appConfig: state.config,
  user: state.user,
  incidentList: state.incidentList
})


const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
      ...filterOperations,
      ...userOperations,
      ...incidentsOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomFiltersDialog)
